<style scoped lang="sass">
.order_items_content
  flex: 1
  display: flex
  flex-direction: column

  .title
    font-size: 12px
    line-height: 16px
    color: var(--menu-primary-text-colour) !important

  .detail
    color: var(--menu-primary-text-colour) !important
    font-size: 12px

.normal_font
  line-height: 17px
</style>

<template lang="pug">
.order_items_content
  .title(:class="{'b': bold}") {{ localizedName }} {{ localizedSizeName ? `(${localizedSizeName})` : '' }}
    .detail
      .required(v-if="data.addList")
        .normal_font(v-for="(items, i) in data.addList" :key="items.id")
          span(v-if="items.type !== 'optional'" v-for="(each, eachIndex) in items.items" :key="each.id")
            span.o5(v-if="!eachIndex") {{ getLocalizedOptName(each) }}{{ each.no > 1 ? ' x' + each.no : '' }}
            span.o5(v-if="eachIndex") {{ ', ' + getLocalizedOptName(each) }}{{ each.no > 1 ? ' x' + each.no : '' }}
      .normal_font(v-for="(item, i) in data.addList" :key="data.id + i" v-if="item.type==='optional'")
        span(v-for="(each, index) in item.items" :key="each.id")
          span.o5(v-if="!index") {{ t('add_label', 'Add:') + ' ' }}
          span.o5(v-if="index") {{ ", " }}
          span.o5 {{ getLocalizedOptName(each) }}{{ each.no > 1 ? ' x' + each.no : '' }}
      .normal_font(v-for="(item, i) in data.removeList" :key="data.id" v-if="item.type==='optional' || 'required'")
        span(v-for="(each, index) in item.items" :key="each.id")
          span.o5(v-if="!index") {{ t('remove_label', 'Remove:') + ' ' }}
          span.o5(v-if="index") {{ ", " }}
          span.o5 {{ getLocalizedOptName(each) }}{{ each.no > 1 ? ' x' + each.no : '' }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { getLocalizedField, t } from '@/utils/language'

@Component({
  props: {
    data: Object,
    bold: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    currentLanguage() {
      return this.$store.state.language?.currentLanguage
    },

    localizedName() {
      return this.data.upgradeProductName || getLocalizedField(this.data, 'name') || this.data.name
    },

    // Get localized size name / 获取本地化的尺寸名称
    localizedSizeName() {
      if (!this.data.selectSize || !this.data.selectSize.name) return ''
      const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
      return getLocalizedField(this.data.selectSize, 'name') || this.data.selectSize.name
    },
  }
})

class OrderItemsContent extends Vue {
  // Translation helper / 翻译辅助函数
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  // Get localized option name / 获取本地化的选项名称
  getLocalizedOptName(option) {
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    return getLocalizedField(option, 'name') || option.name
  }
}

export default OrderItemsContent
</script>
